var XPortal = XPortal || {};
XPortal.DatePicker = (function () {
    var self = {
        ControlSelector: ".data-datepicker, .data-datepicker-readonly",
        ControlSelectorNotInFSet: `.data-datepicker:not(.dynamic-filter-set .data-datepicker),.data-datepicker-readonly:not(.dynamic-filter-set .data-datepicker-readonly)`,
        ControlWithTimeSelector: ".data-datetimepicker, .data-datetimepicker-readonly",
        ControlWithTimeSelectorNotInFSet: `.data-datetimepicker:not(.dynamic-filter-set .data-datetimepicker), .data-datetimepicker-readonly:not(.dynamic-filter-set .data-datetimepicker-readonly)`,

        LocalizePreffix: "XPortal.Frontend.DateTimePicker.",
        LocalizeKeys: {
            set: 'Set',
            cancel: 'Cancel',
            hour: 'hour',
            minute: 'minute',
            second: 'second',
            millisecond: 'millisecond',
            now: 'Now',
            date: 'Date',
            time: 'Time',
            today: 'Today'
        },
        LocalizationResult: null,
        _localizationPromise: null,

        EnsureLocalization: ensureLocalization,
        Init: function (container, exceptFSets) {
            container = container ? container : $(XPortal.Main.DetialFormSelector);
            ensureLocalization().then(function () {
                var modelName = XPortal.Store.getModelName(container[0].id);
                container.find(exceptFSets ? self.ControlSelectorNotInFSet : self.ControlSelector).each(function (ip, element) {
                    var el = jQuery(element);
                    if (el.is("input")) {
                        XPortal.DatePicker.initFor(modelName, element, false);
                    }
                });
                container.find(exceptFSets ? self.ControlWithTimeSelectorNotInFSet : self.ControlWithTimeSelector).each(function (ip, element) {
                    XPortal.DatePicker.initFor(modelName, element, true);
                });
            });
        },
        initFor: function (modelName, element, isWithTime, isInlineEditor = false) {
            var { $el, sttgs, dataSelector } = XPortal.DatePicker.addEvents(element, isWithTime, isInlineEditor, modelName);
            XPortal.DatePicker.initControls(element, isWithTime, $el, sttgs, dataSelector);
        },
        addEvents: function (element, isWithTime, isInlineEditor, modelName) {
            var el = jQuery(element);
            if (moment(el.val()).isValid()) {
                const ival = XPortal.Utils.TransformDateTime(XPortal.Utils.AdjustDT(el.val(), true), (isWithTime ? null : "YYYY-MM-DD"), true, false, true, true, false, false);
                el.val(ival ? ival.toISOString() : "");
            }
            var dataSelector = isWithTime ? "kendoDateTimePicker" : "kendoDatePicker";
            const sttgs = XPortal.Main.GetSettingsFor(el);
            const ftype = sttgs.editor.length ? sttgs.editor.toLowerCase() : sttgs.type.toLowerCase();
            el.on("change", function () {
                if (!isInlineEditor)
                    el.trigger("dispatchFieldEvent");
            });
            el.bind("dispatchFieldEvent", function (e) {
                var curValue = getEditor($(this), isWithTime).value() || "";
                if (curValue) {
                    if (ftype === "datetime") curValue = XPortal.Utils.FormatDateTimeNaive(curValue);
                    else curValue = moment(curValue).format("YYYY-MM-DD");
                }
                XPortal.Store.FieldEvent(element, curValue, modelName, sttgs);
            });

            XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: el }, function render(value) {
                if (el && el.data(dataSelector)) {
                    if (isWithTime && value) {
                        value.processed = true;
                        var fVal = XPortal.Utils.TransformDateTime(value, null, true, false, false, false, false, false)
                        el.data(dataSelector).value(value ? moment.utc(fVal).format() : "");
                        //console.log("StorSbscr:" + sttgs.fieldname + " Val:" + value + " final: " + fVal.format());
                        return;
                    }
                    if (el && el.data(dataSelector))
                        el.data(dataSelector).value(value ? new Date(value) : "");
                }
            });
            return { el, sttgs, dataSelector };
        },
        initControls: function (element, isWithTime, $el = null, sttgs = null, dataSelector = "") {
            if (!$el) $el = jQuery(element);
            if (!dataSelector) dataSelector = isWithTime ? "kendoDateTimePicker" : "kendoDatePicker";
            if (!sttgs) sttgs = XPortal.Main.GetSettingsFor($el);

            var tmpVal = sttgs.value;
            if (tmpVal && tmpVal.length > 0)
                tmpVal = XPortal.Utils.TransformDateTime(sttgs.value, (isWithTime ? null : "YYYY-MM-DD"), true, false, true, true, false, false);

            sttgs.componentType = "modern";

            sttgs.value = (typeof tmpVal.toDate === "function" ? tmpVal.toDate() : tmpVal);
            sttgs.format = XPortal.Template.formatDateToKendo(sttgs.format);
            sttgs.open = function (e) {
                XPortal.Utils.identifyKendoPopup(e);
            };
            sttgs.close = function (e) {
                XPortal.Utils.removeKendoPopupClass(e);
            };
            sttgs.change = function (e) { };
            var elementFormat = $el.attr("data-format");
            if (elementFormat !== sttgs.format) {
                $el.attr("data-format", sttgs.format);
            }
            if (sttgs.format && sttgs.format.length > 0) {
                var parts = sttgs.format.split(" ");
                sttgs.timeFormat = _.filter(parts, function (xp) {
                    const txp = xp.toLowerCase();
                    return txp.indexOf("hh") >= 0 || txp.indexOf("ss") >= 0 || xp.indexOf("mm") >= 0 || txp.indexOf("tt") >= 0 || txp.indexOf("a") >= 0;
                }).join(" ");
            }
            if (isWithTime) {
                sttgs.timeFormat = "HH:mm";
            }

            sttgs.size = "medium";
            sttgs.messages = self.LocalizationResult.localizedTexts;

            isWithTime ? $el.kendoDateTimePicker(sttgs) : $el.kendoDatePicker(sttgs);
            try {
                $el.data(dataSelector).setOptions({ format: sttgs.format });
            } catch (err) { console.log(sttgs, err); }
            if (!sttgs.editable) {
                const picker = $el.data(dataSelector);
                picker.enable(false);
                picker.readonly();
            }
            else if (!isWithTime) {
                $el.closest(".k-widget").on("click", function () { $el.data(dataSelector).open(); });
            }
        },
        ensurePrototypeInited: function () {
            $.extend(true, kendo.ui.Calendar.prototype.options.messages, {
                today: self.LocalizationResult.localizedTexts.today,
            });
        }
    };
    function getEditor(el, isWithTime) {
        if (!el) return null;
        return el.data(isWithTime ? "kendoDateTimePicker" : "kendoDatePicker");
    };
    function ensureLocalization() {
        if (!self._localizationPromise) {
            self._localizationPromise = XPortal.Localization.EnsureLocalizedTexts(self.LocalizePreffix, self.LocalizeKeys)
                .then(function (result) {
                    self.LocalizationResult = result;
                    self.ensurePrototypeInited();
                    return result;
                })
                .catch(function (error) {
                    self._localizationPromise = null;
                    throw error;
                });
        }

        return self._localizationPromise;
    };
    return self;
}());